import React, {Component, Fragment} from "react";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import * as R from "ramda";

class OnSubmissionHeaderInputModifying extends Component {
    render() {
        return (
            <Fragment>
                <div style={{marginBottom: "50px"}}>
                    <div className="grid grid-3x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleInput
                                id="input_text_submission_number"
                                name="nomorPengajuan"
                                label="Nomor Pengajuan"
                                readOnly
                                value={this.props.controls.nomorPengajuan.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_submission_date"
                                name="tanggalPengajuan"
                                label="Tanggal Pengajuan"
                                readOnly
                                value={this.props.controls.tanggalPengajuan.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                        </div>
                        <div id="grid-2">
                            {R.equals(this.props.action, "view") ? (
                                <>
                                    <SimpleInput
                                        id="input_text_samsat_name"
                                        name="kodeSamsat"
                                        label="Nama Samsat"
                                        readOnly
                                        value={this.props.controls.kodeSamsat.value?.label}
                                    />
                                    <SimpleInput
                                        id="input_text_birojasa_name"
                                        name="noSupplier"
                                        label="Nama Birojasa"
                                        readOnly
                                        value={this.props.controls.noSupplier.value?.label}
                                    />
                                    <SimpleInput
                                        id="input_text_tabel_bbn"
                                        name="tableBBN"
                                        label="Tabel BBN"
                                        value={this.props.controls.bbnId.value?.label}
                                        readOnly
                                    />
                                </>
                            ) : (
                                <>
                                    <SimpleDDL
                                        id="select_options_samsat_name"
                                        box="search"
                                        name="kodeSamsat"
                                        label="Nama Samsat"
                                        isClearable={true}
                                        options={this.props.dataSamsat}
                                        value={this.props.controls.kodeSamsat.value}
                                        onChange={(value, {name}) => {
                                            this.props.setValue(name, value)
                                            this.props.setValue("noSupplier", null)
                                            this.props.setValue("bbnId", null)
                                        }}
                                    />
                                    <SimpleDDL
                                        id="select_options_birojasa_name"
                                        box="search"
                                        name="noSupplier"
                                        label="Nama Birojasa"
                                        isClearable={true}
                                        options={this.props.dataSupplier}
                                        value={this.props.controls.noSupplier.value}
                                        onChange={(value, {name}) => this.props.setValue(name, value)}
                                    />
                                    <SimpleDDL
                                        id="select_options_tabel_bbn"
                                        box="search"
                                        name="bbnId"
                                        label="Tabel BBN"
                                        isClearable={true}
                                        options={this.props.dataBBN}
                                        value={this.props.controls.bbnId.value}
                                        onChange={(value, {name}) => this.props.setValue(name, value)}
                                    />
                                </>
                            )}

                        </div>
                        <div id="grid-3">
                            <SimpleInput
                                id="input_text_bkk_number"
                                name="noBKK"
                                label="Nomor BKK"
                                readOnly
                                value={this.props.controls.noBKK.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default OnSubmissionHeaderInputModifying;